$mol_attach $mol_view
	items? /string
	sub <= content /$mol_view
		<= Item*0 $mol_button_minor
			click? <=> item_drop*? null
			sub /
				<= Image* $mol_image
					title \
					uri <= item_uri* \
		<= Add $mol_button_open
			title <= attach_title \
			files? <=> attach_new? null
